import React, { useState } from "react";
import FormLayout from "../RecipientManagement/FormLayout";
import { useForm } from "react-hook-form";
import InputField from "../RecipientManagement/InputField";
import LoadingButton from "../RecipientManagement/LoadingButton";
import { postPasswordAPI } from "../../Api/postPasswordAPI";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
export const ChangePassword = () => {
  const [load, setLoad] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset
  } = useForm();
//  const {}
  const { selfInfo,accessToken} = useSelector((state) => state.adminReducers);

  const handleChangePassword = async (payload) => {
    const mainpayload ={
        old_password: payload?.old_password,
        new_password:payload?.new_password,
        confirm_password:payload?.confirm_new_password,
        email:selfInfo?.email
      }
  try {
    const data = await postPasswordAPI('user/change_password',mainpayload,accessToken);

    if(data?.status===200){
        toast.success(data?.data?.message)
        reset()
    }else if (data?.data?.error){
        toast.error(data?.data?.error)
    }else{
      toast.error(data?.data?.error)
    }
    setLoad(false)
  } catch (err) {
    setLoad(false)
  }
};

  const onSubmit = (data) => {
    if (data?.confirm_new_password === data?.new_password) {
     setLoad(true)
     handleChangePassword(data)
    } else {
      setError("confirm_new_password", {
        type: "manual",
        message: "Password does not match",
      });
    }
  };
  return (
    <FormLayout title="Change Password">
      <form onSubmit={handleSubmit(onSubmit)} className="container">
        <div className="row">
          <div className="col-md-4">
            <InputField
              label="Old Password"
              name="old_password"
              register={register}
              required
              errors={errors}
              type="password"
              isPassword={true}
              placeholder="Enter Previous Password"
            />
          </div>
          <div className="col-md-4 ">
            <InputField
              label="New Password"
              name="new_password"
              register={register}
              required
              type="password"
              isPassword={true}
              errors={errors}
              placeholder="Enter New Password"
            />
          </div>
          <div className="col-md-4 ">
            <InputField
              label="Confirm New Password"
              name="confirm_new_password"
              register={register}
              required
              type="password"
              isPassword={true}
              errors={errors}
              placeholder="Confirm New Password"
            />
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-12 d-flex gap-2 mt-3">
            <LoadingButton loading={load} text={"Save"} />
          </div>
        </div>
      </form>
    </FormLayout>
  );
};

export default ChangePassword;
